// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__38TdH","label":"Completed_label__y2etP"};